cb.define(['common/common_VM.Extend.js'], function (common) {

    var changeDate = function (viewmodel) {

        var promotionPlanActivity = viewmodel.get("promotionPlanActivity").getData();

        viewmodel.get("startDate").setValue(undefined);
        viewmodel.get("endDate").setValue(undefined);

        for (let i = 0; i < promotionPlanActivity.length; i++) {
            if (promotionPlanActivity[i]._status === 'Delete')
                continue;
            let newStartDate = new Date(promotionPlanActivity[i].startDate);
            let oldStartDate = viewmodel.get("startDate").getValue();
            let newEndDate = new Date(promotionPlanActivity[i].endDate);
            let oldEndDate = viewmodel.get("endDate").getValue();
            if (oldStartDate === undefined || newStartDate < new Date(oldStartDate)) {
                viewmodel.get("startDate").setValue(promotionPlanActivity[i].startDate);
            }
            if (oldEndDate === undefined || newEndDate > new Date(oldEndDate)) {
                viewmodel.get("endDate").setValue(promotionPlanActivity[i].endDate);
            }
        }
    };

    var PM_pmc_promotionplan_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            viewmodel.get("promotionPlanActivity").on('afterCellValueChange', function (data) {
                changeDate(viewmodel);
            });

            viewmodel.get("promotionPlanActivity").on('afterDeleteRows', function (rows) {
                changeDate(viewmodel);
            });

            viewmodel.get("promotionPlanActivity").on('afterSetDataSource', () => {
                const rows = viewmodel.get("promotionPlanActivity").getRows();
                const actions = viewmodel.get("promotionPlanActivity").getCache('actions');
                const actionsStates = [];
                rows.forEach(data => {
                    const actionState = {};
                    actions.forEach(action => {
                        if (action.cItemName == "btnDisAble") {

                            if (data.valid == 0) {
                                actionState[action.cItemName] = {visible: false};
                            } else {
                                actionState[action.cItemName] = {visible: true};
                            }
                        } else if (action.cItemName == "btnEnAble") {
                            if (data.valid == 0) {
                                actionState[action.cItemName] = {visible: true};
                            } else {
                                actionState[action.cItemName] = {visible: false};
                            }
                        } else {
                            actionState[action.cItemName] = {visible: true};
                        }
                    });
                    actionsStates.push(actionState);
                });
                viewmodel.get("promotionPlanActivity").setActionsState(actionsStates);
            });

            viewmodel.on('beforeSave', function (data) {
                var obj = JSON.parse(data.data.data);
                obj.num = 0;
                for (let i = 0; i < viewmodel.get("promotionPlanActivity").getData().length; i++) {
                    if (viewmodel.get("promotionPlanActivity").getData()[i]._status != "Delete") {
                        obj.num += 1;
                    }
                }
                data.data.data = JSON.stringify(obj);
            });

            viewmodel.on('beforeEdit', function (args) {
                if (args.params.params != null) {
                    var index = args.params.params.index;
                    var params = {
                        mode: 'browse',
                        readOnly: true,
                        id: viewmodel.get("promotionPlanActivity").getData()[index].activityId
                    };
                    var data = {
                        billtype: 'voucher',
                        billno: common.getBillNo(viewmodel.get("promotionPlanActivity").getData()[index].type),
                        params: params
                    };
                    cb.loader.runCommandLine('bill', data, viewmodel);
                    return false;
                }
            });

        }
    };

    try {
        module.exports = PM_pmc_promotionplan_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_promotionplan_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_promotionplan_VM.Extend.js